"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toEnum = exports.getKeys = exports.getEnumValue = exports.checkAllPropertiesExist = exports.creditAgreementFullArtifact = exports.isXlsxTemplateProperty = exports.isValidNotificationSubType = exports.isStringArray = exports.isSlackWebApiPlatformError = exports.isServicerReportProperty = exports.isNumberArray = exports.isFundingRequestGeneralPropertiesOrComponentType = exports.isFundingRequestComponentType = exports.isFinleyErrorType = exports.isErrorType = exports.isDocxtemplaterErrorType = exports.isDataTapeProperty = exports.isCreditFacilitySlugs = exports.isCreditFacilitySlug = exports.isCashResponseTape = exports.isBorrowingBaseContributionAccountType = exports.isBorrowerBankAccountType = exports.isBankAccountType = exports.isLoanProductSlug = exports.isFullDateTimeStr = exports.isDateTimeZone = exports.isISO8601Date = exports.isFullDateStr = void 0;
exports.isNotNullOrUndefined = isNotNullOrUndefined;
const _ = __importStar(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
const consts = __importStar(require("../consts"));
const error_1 = require("../error");
Object.defineProperty(exports, "isErrorType", { enumerable: true, get: function () { return error_1.isErrorType; } });
Object.defineProperty(exports, "isFinleyErrorType", { enumerable: true, get: function () { return error_1.isFinleyErrorType; } });
const creditAgreementFullArtifact = __importStar(require("./creditAgreementFullArtifact"));
exports.creditAgreementFullArtifact = creditAgreementFullArtifact;
const utils_1 = require("./utils");
Object.defineProperty(exports, "checkAllPropertiesExist", { enumerable: true, get: function () { return utils_1.checkAllPropertiesExist; } });
Object.defineProperty(exports, "getEnumValue", { enumerable: true, get: function () { return utils_1.getEnumValue; } });
Object.defineProperty(exports, "getKeys", { enumerable: true, get: function () { return utils_1.getKeys; } });
Object.defineProperty(exports, "toEnum", { enumerable: true, get: function () { return utils_1.toEnum; } });
const isBorrowerBankAccountType = (test) => {
    return test && _.includes(_.values(finley_types_1.Bank.BorrowerAccountType), test);
};
exports.isBorrowerBankAccountType = isBorrowerBankAccountType;
const isCapitalProviderBankAccountType = (test) => {
    return test && _.includes(_.values(finley_types_1.Bank.CapitalProviderAccountType), test);
};
const isBankAccountType = (test) => {
    return (test &&
        (isBorrowerBankAccountType(test) || isCapitalProviderBankAccountType(test)));
};
exports.isBankAccountType = isBankAccountType;
const isBorrowingBaseContributionAccountType = (test) => {
    return test && consts.borrowingBaseContributionAccountTypes.includes(test);
};
exports.isBorrowingBaseContributionAccountType = isBorrowingBaseContributionAccountType;
const isFullDateStr = (dateStr) => {
    return (dateStr &&
        typeof dateStr === 'string' &&
        consts.regExpFullDateStr.test(dateStr));
};
exports.isFullDateStr = isFullDateStr;
// Within Finley systems, ISO 8601 date is a FullDateStr
// The current type definition for FullDateStr
// The annotated pattern is defined similarly at: https://github.com/finleytechnologies/atlas/blob/development/packages/universal/finley-types/source/types/Utils.ts#L11
// There are minor variances in the format, but do not seem to express themselves differently when tested
const isISO8601Date = (dateString) => {
    // Regular expression to match ISO 8601 date format "yyyy-LL-dd"
    const iso8601Regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    // Check if the date string matches the regex
    if (!iso8601Regex.test(dateString)) {
        return false;
    }
    // Parse the date components
    const [year, month, day] = dateString.split('-').map(Number);
    // Create a Date object using the parsed components
    const date = new Date(year, month - 1, day);
    // Check if the Date object represents the same date as the input string
    return (date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day);
};
exports.isISO8601Date = isISO8601Date;
const isDateTimeZone = (tz) => _.includes(_.values(finley_types_1.Util.DateTimeZones), tz);
exports.isDateTimeZone = isDateTimeZone;
const isFullDateTimeStr = (datTimeStr) => {
    return (datTimeStr &&
        typeof datTimeStr === 'string' &&
        consts.regExpFullDateTimeStr.test(datTimeStr));
};
exports.isFullDateTimeStr = isFullDateTimeStr;
/**
 * see if this is a valid DocxtemplaterError type for our error handling
 * @param err potential error
 * @returns boolean true if typeof error
 */
const isDocxtemplaterErrorType = (err) => {
    return (0, error_1.isErrorType)(err) && 'properties' in err;
};
exports.isDocxtemplaterErrorType = isDocxtemplaterErrorType;
/**
 * Check whether the error is a Slack webapi platform error type for error handling
 * @param err potential error
 * @returns boolean true if typeof error
 */
const isSlackWebApiPlatformError = (err) => {
    return ((0, error_1.isErrorType)(err) &&
        err.code === 'slack_webapi_platform_error');
};
exports.isSlackWebApiPlatformError = isSlackWebApiPlatformError;
const isCreditFacilitySlug = (test) => {
    // TODO: backend validation of a valid slug would be ideal.
    return _.isString(test);
};
exports.isCreditFacilitySlug = isCreditFacilitySlug;
const isCreditFacilitySlugs = (test) => {
    return _.isArray(test) && _.every(test, isCreditFacilitySlug);
};
exports.isCreditFacilitySlugs = isCreditFacilitySlugs;
const isFundingRequestComponentType = (val) => {
    const types = finley_types_1.FundingRequest.FundingRequestComponentTypeSchema.options;
    return val && _.includes(types, val);
};
exports.isFundingRequestComponentType = isFundingRequestComponentType;
const isFundingRequestGeneralPropertiesOrComponentType = (val) => {
    const types = [
        'properties',
        ...finley_types_1.FundingRequest.FundingRequestComponentTypeSchema.options,
    ];
    return val && _.includes(types, val);
};
exports.isFundingRequestGeneralPropertiesOrComponentType = isFundingRequestGeneralPropertiesOrComponentType;
const isLoanProductSlug = (test) => {
    // TODO: backend validation of a valid slug would be ideal.
    return _.isString(test);
};
exports.isLoanProductSlug = isLoanProductSlug;
const isServicerReportProperty = (propertyKey) => {
    return _.includes(Object.values(finley_types_1.Report.ReportXlsxTemplate.ServicerReportProperty), propertyKey);
};
exports.isServicerReportProperty = isServicerReportProperty;
const isDataTapeProperty = (propertyKey) => {
    return _.includes([
        ...Object.values(finley_types_1.Report.ReportXlsxTemplate.LoanProductDataTape),
        ...Object.values(finley_types_1.Report.ReportXlsxTemplate.OtherDataTape),
    ], propertyKey);
};
exports.isDataTapeProperty = isDataTapeProperty;
const isBorrowerEmailType = (test) => {
    return _.includes(_.values(finley_types_1.Notifications.BorrowerEmailType), test);
};
const isBorrowerSlackType = (test) => {
    return _.includes(_.values(finley_types_1.Notifications.BorrowerSlackNotificationType), test);
};
const isCapitalProviderEmailType = (test) => {
    return _.includes(_.values(finley_types_1.Notifications.CapitalProviderEmailType), test);
};
const isWebhookType = (test) => {
    return _.includes(_.values(finley_types_1.Notifications.WebhookType), test);
};
const isValidNotificationSubType = (notificationType, notificationSubType) => (notificationType === 'email' && isBorrowerEmailType(notificationSubType)) ||
    (notificationType === 'email' &&
        isCapitalProviderEmailType(notificationSubType)) ||
    (notificationType === 'slack' && isBorrowerSlackType(notificationSubType)) ||
    (notificationType === 'webhook' && isWebhookType(notificationSubType));
exports.isValidNotificationSubType = isValidNotificationSubType;
const isStringArray = (obj) => _.isArray(obj) && _.every(obj, (el) => _.isString(el));
exports.isStringArray = isStringArray;
const isNumberArray = (obj) => _.isArray(obj) && _.every(obj, (el) => typeof el === 'number');
exports.isNumberArray = isNumberArray;
const isXlsxTemplateProperty = (test) => {
    return _.keys(finley_types_1.Report.ReportXlsxTemplate.xlsxTemplateProperty).includes(test);
};
exports.isXlsxTemplateProperty = isXlsxTemplateProperty;
function isNotNullOrUndefined(value) {
    return value !== undefined && value !== null;
}
const isBankAccountCashBalance = (obj) => {
    return (obj &&
        'bankAccountId' in obj &&
        'balance' in obj &&
        'accountType' in obj &&
        (isBorrowingBaseContributionAccountType(obj.accountType)
            ? 'cashAdvanceRate' in obj
            : true));
};
const isCashResponseTape = (obj) => {
    return (obj &&
        'creditFacilityId' in obj &&
        'reportingDate' in obj &&
        'fileVersion' in obj &&
        'bankAccountCashBalances' in obj &&
        obj.bankAccountCashBalances.every(isBankAccountCashBalance));
};
exports.isCashResponseTape = isCashResponseTape;
//# sourceMappingURL=index.js.map